// components/BookResults.tsx
"use client";

import { useState, useEffect, useMemo } from "react";
import BookShelf from "./BookShelf/BookShelf";
import Header from "./Header/Header";
import { BookInterface } from "./books/types/book";
import { useSearchParams } from "next/navigation";

interface BookResultsProps {
  initialBooks: BookInterface[];
  searchId: string;
  query: string;
  initialWorkUrn?: string;
}

export default function BookResults({ initialBooks, searchId, query,  }: BookResultsProps) {
  const [displayQuery, setDisplayQuery] = useState(query);
  const searhParams = useSearchParams()
  const work_urn = searhParams.get('work_urn') ?? undefined;
useEffect(() => {
  // Always update display query when the query prop changes (URL/navigation changes)
  setDisplayQuery(query);
  
  // Only use lastExactQuery if we're on the same page as the search
  const exactQuery = sessionStorage.getItem('lastExactQuery');
  
  if (exactQuery) {
    // Create slugified version of exactQuery to compare with URL query
    const slugifiedExactQuery = exactQuery
      .toLowerCase()
      .replace(/[\/\?\#\:\*\[\]\@\!\$\&\'\(\)\+\,\;\=]/g, '-')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
    
    // Only use the lastExactQuery if it matches the current page's query
    if (query === slugifiedExactQuery) {
      setDisplayQuery(exactQuery);
    }
  }
}, [query]);
const books = useMemo(() => {
  if (!Array.isArray(initialBooks)) {
    // Capture exception to Sentry with context
    if (typeof window !== 'undefined' && window.Sentry) {
      window.Sentry.captureException(new Error('initialBooks is not an array'), {
        tags: {
          component: 'BookResults',
        },
        extra: {
          initialBooksType: typeof initialBooks,
          initialBooksValue: initialBooks,
          query: displayQuery,
          searchId: searchId,
          work_urn: work_urn
        }
      });
    }
    
    // Log to console in development
    console.error('initialBooks is not an array:', { 
      type: typeof initialBooks, 
      value: initialBooks 
    });
    
    return [];  // Return empty array to prevent UI errors
  }
  const booksCopy = [...initialBooks];
  
  if (work_urn) {
    const urlBookIndex = booksCopy.findIndex(book => book.work_urn === work_urn);
    if (urlBookIndex > 0) {
      // Move the URL-specified book to position 0
      const bookToMove = booksCopy.splice(urlBookIndex, 1)[0];
      booksCopy.unshift(bookToMove);
    }
  }
  
  return booksCopy;
}, [initialBooks, work_urn]);

  return (
    <div className="flex-col items-center justify-center">
      <Header/>
      <div className="book-list">
        <BookShelf 
          books={books}
          share_id={searchId} 
          query={displayQuery}
        />
      </div>
    </div>
  );
}